import React, { useCallback, useState } from "react";
import ListHeader from "../../common/list/ListHeader";
import ListActions from "../../common/list/ListActions";
import NavigationPagination from "../../common/NavigationPagination";
import { useGetTemplatesQuery } from "../../../services/api/repositories/TemplateMailsRepository";
import TableTemplates from "./TableTemplates";
import { useNavigate } from "react-router-dom";
import PreviewModal from "./common/PreviewModal";

export default function TemplatesSection() {
    const navigate = useNavigate();

    const [currentPage, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const {data, isLoading, isFetching, } = useGetTemplatesQuery(
        {page: currentPage, per_page: perPage},
        {refetchOnMountOrArgChange: true}
    );

    const handleAction = useCallback(() => {
        navigate("/templates/new");
    }, [navigate]);

    const [showPreview, setShowPreview] = useState(false);
    const [previewData, setPreviewData] = useState({name: "", uuid: ""});
    
    const handleClose = useCallback(() =>{
        setShowPreview(false)
        setPreviewData({name: "", uuid: ""});
    }, [setShowPreview, setPreviewData]);

    const handleShowPreview = useCallback((name: string, uuid: string) => {
        if(name === "" || uuid === "") {
            return;
        }
        setPreviewData({name, uuid});
        setShowPreview(true);
    }, [setShowPreview, setPreviewData]);

    return (
        <>
            <ListHeader 
                actions={                    
                    <ListActions
                        classAction='btn-add'
                        title="Ajouter un Template email"
                        textButton="Ajouter un Template email"
                        handleAction={handleAction}
                    />
                }
                handleSubmit={() => console.log('Submit')}
                handleReset={() => console.log('Reset')}
            >
            </ListHeader>

            {(isLoading || isFetching) && <p>Chargement...</p>}
        
            {((!isLoading && !isFetching) && data !== undefined) && (
                <>
                    {("message" in data) && <p>{data.message}</p>}
                    {("total" in data) && 
                    (<>
                        <TableTemplates data={data} handleShowPreview={handleShowPreview}/>
                        <NavigationPagination currentPage={currentPage} lastPage={data.last_page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} />              
                    </>)}
                </>
                )
            }
            
            {((!isLoading && !isFetching) && data === undefined) && 
                <p>Une erreur a été rencontrée.</p>
            }

            {previewData.name !=="" && previewData.uuid !== "" &&
                <PreviewModal show={showPreview} handleClose={handleClose} name={previewData.name} uuid={previewData.uuid} />
            }
        </>
    );
}